export default __webpack_public_path__ + "static/jersey-group-02-2c72ea5824c619cf3a32969c9113982d.jpg";